import styled from 'styled-components';
import { ampli } from '../../../../../ampli';
import { YoutubeSection } from '../../../../../components/common/video/YoutubeSection';
import { IProduct } from '../../../../../interfaces/Product.interfaces';
import { SectionTitle } from './SectionTitle';

interface ProductYoutubeSectionProps {
  product: IProduct;
  pageType?: 'odp' | 'pdp' | 'new-product';
  productIndexOnList?: number;
  title?: string;
}

export const ProductYoutubeSection = ({ product, pageType, productIndexOnList, title }: ProductYoutubeSectionProps) => {
  return (
    <Container>
      <SectionTitle>{title || '생생한 동영상 리뷰'}</SectionTitle>
      <YoutubeSection
        youtubeUrl={product.youtubeUrl}
        onPlay={() => {
          if (pageType === 'new-product' && !!productIndexOnList) {
            ampli.pvmClickNewProductVideo({
              id: product.id,
              index: productIndexOnList.toLocaleString(),
            });
          }
        }}
      />
    </Container>
  );
};

const YoutubeWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  display: flex;
  padding: 32px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;
